import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useGithubIsConnected(tenant: number) {
  return useQuery<boolean>({
    queryKey: ['github', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/github/ping`
      );

      return !!data?.valid;
    },
  });
}
